import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './baseQuery';
import { IPagedResult } from '../../shared/models/paged-result';
import { serialize } from '../../utility/serialize';
import { IDiscount } from '../../shared/models/discount/discount';
import { IDiscountListItem } from '../../shared/models/discount/discount-list-item';
import { IDiscountFilterSet } from '../../shared/models/discount/discount-filter-set';

const discountApi = createApi({
  reducerPath: 'discountApi',
  baseQuery,
  endpoints: (builder) => ({
    getDiscounts: builder.query<
      IPagedResult<IDiscountListItem>,
      IDiscountFilterSet | string | void
    >({
      query: (filterSet) => {
        const qs = filterSet ? `?${serialize(filterSet)}` : '{"page":"1","size":"50"}';
        return {
          url: `/api/discounts${qs}`,
          method: 'GET',
        };
      },
    }),
    getDiscount: builder.query<IDiscount, string>({
      query: (id) => ({
        url: `/api/discounts/${id}`,
        method: 'GET',
      }),
      keepUnusedDataFor: 0,
    }),
    createDiscount: builder.mutation<IDiscountListItem, IDiscount>({
      query: (body) => ({
        url: '/api/discounts',
        method: 'POST',
        body,
      }),
    }),
    updateDiscount: builder.mutation<IDiscountListItem, IDiscount>({
      query: (body) => ({
        url: `/api/discounts/${body.id}`,
        method: 'PUT',
        body,
      }),
    }),
    deleteDiscount: builder.mutation<boolean, string>({
      query: (id) => ({
        url: `/api/discounts/${id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export { discountApi };

export const {
  useGetDiscountQuery,
  useLazyGetDiscountsQuery,
  useCreateDiscountMutation,
  useUpdateDiscountMutation,
  useDeleteDiscountMutation,
} = discountApi;
